<template>
  <div v-loading="isLoading">
    <arvore-filter v-show="filterIsVisible" :filter-is-visible.sync="filterIsVisible"></arvore-filter>
    <template v-show="!filterIsVisible">
      <el-row v-if="!hasData">
        <el-col>
          <el-alert
            title=" Sem Dados. Faça um filtro"
            type="info"
            show-icon>
          </el-alert>
        </el-col>
      </el-row>
      <el-row v-else>
        <el-col :span="6">
          <el-card class="mr-1">
            <div slot="header" class="clearfix">
              <strong>Grupos</strong>
            </div>
            <ul class="list-group">
              <li v-bind:class="{ 'indicador-active': indicador.id === indicadorSelected.id }"
                  class="list-group-item clickable" v-for="indicador in parents" @click="onChangeGrupo(indicador)">
                <span style="font-size: .8em ; font-weight: bold"> {{indicador.nome}}</span>
              </li>
            </ul>
          </el-card>
        </el-col>
        <transition name="fade" mode="out-in">
          <el-col :span="18" v-if="indicadorSelected" v-show="changeGroupTransition">
            <el-card class="box-card">
              <div slot="header" class="clearfix">
                <strong> {{indicadorSelected.nome}} Indicadores</strong>
                <el-button-group class="pull-right">
                  <el-tooltip v-if="canChange" content="Restaurar pesos para a Origem [Árvore]" placement="top">
                    <el-button size="mini" type="danger" @click="confirmarRestaurarPesos" icon="fa  fa-undo"
                               class="mr-2"></el-button>
                  </el-tooltip>
                  <el-tooltip v-if="canChange" content="Salvar" placement="top">
                    <el-button size="mini" type="success" @click="salvar" icon="fa fa-floppy-o"
                               class="mr-2"></el-button>
                  </el-tooltip>
                  <el-tooltip v-if="canChange" content="Atualizar Metas do Centros de Custos"
                              placement="top">
                    <i class="fa-2x icon-share-alt clickable" @click="updateMetas"></i>
                  </el-tooltip>
                  <el-tooltip content="Filtro"
                              placement="top">
                    <i class="fa-2x fa fa-filter pull-right clickable" @click="filterIsVisible = true"></i>
                  </el-tooltip>
                </el-button-group>
              </div>
              <table class="table table-striped table-bordered table-sm">
                <thead class="thead-dark">
                <tr>
                  <th class="text-center">ID</th>
                  <th class="text-center">Peso Orig</th>
                  <th class="text-center">Peso</th>
                  <th class="text-center">#</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="item in listChildrens" key="item.indicador_id">
                  <td style="font-size: .8em ; font-weight: bold">{{item.indicador_nome}}</td>
                  <td class="text-right">
                    <el-input-number :disabled="true" v-model="item.peso_periodo" :controls="false"
                                     size="small"></el-input-number>
                  </td>
                  <td class="text-right">
                    <el-input-number v-model="item.peso" :controls="false" size="small"></el-input-number>
                  </td>
                  <td class="text-right">
                    <el-switch
                      v-model="item.ativo"
                      :active-value="1"
                      :inactive-value="0"></el-switch>
                  </td>
                </tr>
                </tbody>

                <tbody>
                <tr>
                  <td></td>
                  <td></td>
                  <td class="text-right">
                    <strong>{{somaDoPesos}}</strong>
                  </td>
                  <td></td>
                </tr>
                </tbody>
              </table>
            </el-card>
          </el-col>
        </transition>
      </el-row>
    </template>
  </div>
</template>

<script>
  import {mapActions, mapState} from 'vuex'
  import {MessageBox, Notification} from 'element-ui'
  import MetaCopy from "./MetaCopy"
  import ArvoreFilter from './ArvoreFilter'

  export default {
    name: "CompetenciaArvore",
    components: {MetaCopy, ArvoreFilter},
    props: ['competencia' , 'canChange'],
    data() {
      return {
        filterIsVisible: true,
        changeGroupTransition: true,
        form: {
          ano: null,
          mes: null,
          arvoreId: null
        },
        arvore: null,
        copyShow: false,
        listChildrens: [],
        isLoading: false,
        indicadorSelected: {},
        indicadorRaiz: {indicador_id: null, indicador_nome: 'Raiz'},
        folhas: []
      }
    },
    computed: {
      ...mapState(['anoSelected', 'mesSelected', 'arvoreList',
        'anos', 'meses', 'indicadorList']),
      hasData() {
        return this.folhas.length > 0
      },
      parentIds() {
        return collect(this.folhas).where('ativo', 1).pluck('parent_id').unique().all()
      },
      parents() {
        const raiz = {id: 0, nome: 'Raiz'}
        return collect(this.indicadorList).whereIn('id', this.parentIds).prepend(raiz).all();
      },
      childrens() {
        return collect(this.folhas).filter(function (value, key) {
          return value.parent_id != null;
        }).all();
      },
      isGrupoRaiz() {
        return this.indicadorRaiz.id === this.indicadorSelected.id
      },
      somaDoPesos() {
        const total = collect(this.listChildrens).where('ativo', 1).sum('peso')
        return _.isNumber(total) ? total.toFixed(2) : 0
      },
      competenciaLabel() {
        if (!this.form.ano || !this.form.mes) {
          return "";
        }
        return ` - ${this.arvore.nome} ${this.form.ano}/${this.form.mes}`
      }
    },
    methods: {
      ...mapActions('Competencia', ['restaurarPesos', 'atualizarfolhas']),
      onChangeGrupo(indicador) {
        this.indicadorSelected = {...indicador}
        this.changeGroupTransition = false
        let ordemParent = this.indicadores_ordem[indicador.id]
        this.listChildrens = collect(this.folhas)
          .where('parent_id', indicador.id)
          .sortBy(function (meta, key) {
            return collect(ordemParent).search(meta.indicador_id)
          }).all()
        this.changeGroupTransition = true
      },
      async salvar() {
        try {
          await MessageBox.confirm("Deseja atualizar os dados?", "ATENÇÃO", {type: 'warning'})
          this.isLoading = true
          const keysValid = ['ativo', 'indicador_id', 'peso', 'id']
          const folhasAjutadas = [...this.listChildrens.map(item => _.pick(item, keysValid))]
          const {data} = await axios.put(`${process.env.API_PATH}/arvore/${this.form.arvoreId}/competencia/${this.form.ano}/${this.form.mes}/`, {folhas: folhasAjutadas})
          this.isLoading = false
          Notification.success("Árvore atualizada com sucesso.")
          await this.load(this.form.ano, this.form.mes, this.form.arvoreId)
        } catch (error) {
          console.log(error)
          Notification.info("Atualização Cancelada.")
        } finally {
          this.isLoading = false
        }
      },
      async updateMetas() {
        try {
          await MessageBox.confirm(`Deseja atualizar as metas de TODOS os Centros de Custos que usam a Árvore ${this.arvore.nome} ?`, "ATENÇÃO", {type: 'warning'});
          this.isLoading = true;
          const {data} = await axios.put(`${process.env.API_PATH}/arvore/${this.form.arvoreId}/competencia/${this.form.ano}/${this.form.mes}/apply`);
          this.isLoading = false;
          Notification.success("Árvore atualizada com sucesso.");
          await this.load(this.form.ano, this.form.mes, this.form.arvoreId);
        } catch (error) {
          console.log(error);
          Notification.info("Atualização Cancelada.");
        } finally {
          this.isLoading = false;
        }
      },
      async confirmarRestaurarPesos() {
        try {
          await MessageBox.confirm("Deseja restaurar os PESOS?", "ATENÇÃO", {type: 'warning'});
          this.isLoading = true;
          let {id} = this.indicadorSelected;
          id = id === null ? 0 : id;
          const {data} = await axios.put(`${process.env.API_PATH}/arvore/${this.form.arvoreId}/competencia/${this.form.ano}/${this.form.mes}/restaurarpesos`);
          Notification.success("Pesos Restaurados com sucesso");
          await this.load(this.form.ano, this.form.mes, this.form.arvoreId);
        } catch (error) {
          console.log(error);
          Notification.info("Restauração Cancelada.");
        } finally {
          this.isLoading = false;
        }
      },
      async load(ano, mes, arvoreId) {
        try {
          this.isLoading = true
          this.filterIsVisible = false
          const {data} = await axios.get(`${process.env.API_PATH}/arvore/${arvoreId}/competencia/${ano}/${mes}/`)
          this.folhas = [...data.folhas].map(item => {
            let newItem = {...item}
            newItem.parent_id = _.isNull(item.parent_id) ? 0 : item.parent_id
            return newItem
          })
          this.arvore = {...data.arvore}
          this.indicadores_ordem = {...data.indicadores_ordem}
          if (this.folhas.length > 0) {
            let indicadorInicial = this.indicadorSelected.hasOwnProperty('id') ? this.indicadorSelected : this.parents[0]
            this.onChangeGrupo(indicadorInicial)
          }

        } catch (e) {
          console.log(e)
        } finally {
          this.isLoading = false
        }
      }
    },
    watch: {
      async competencia(newCompetencia) {
        await this.load(newCompetencia.ano, newCompetencia.mes, this.form.arvoreId)
      }
    },
    async mounted() {
      this.$bus.$on('ArvoreHandleForm', async e => {
        this.form = {...e}
        await this.load(this.competencia.ano, this.competencia.mes, this.form.arvoreId)
      })
    }
  }
</script>

<style scoped>
  .indicador-active {
    background-color: #9933CC;
    color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/features/Competencia/Arvore.vue